import { RequirementType } from "@wingspanhq/payments/dist/interfaces";
import { SharedFileRequestContextType } from "@wingspanhq/shared-files/dist/lib/interfaces";
import { IPolicyType } from "../../../services/api/insurance/coverage/types";
import { TEMPLATES } from "../routes/RouteCreateRequirementByTemplate/templates";
import { RequirementDefinitionTemplate } from "../routes/RouteCreateRequirementByTemplate/types";
import startCase from "lodash/startCase";
import upperFirst from "lodash/upperFirst";
import toLower from "lodash/toLower";
import intersection from "lodash/intersection";
import { selectorIsContextTypesMatched } from "../../Requirements/modules/InsuranceCoverage/selectors/selectorIsContextTypesMatched";

const sentenceCase = (str: string) => upperFirst(toLower(startCase(str)));

export function getRequirementDefinitionTemplateByParams(params: {
  type: RequirementType;
  contextType?: SharedFileRequestContextType;
  policyType?: IPolicyType[];
  strict?: boolean;
}): RequirementDefinitionTemplate {
  let template = TEMPLATES.find(template => {
    const isRequirementTypeMatched = template.requirementType === params.type;

    const isContextTypeMatched = template.contextType
      ? selectorIsContextTypesMatched(params, template.contextType)
      : true;

    const isPolicyTypeMatched = template.policyType
      ? !!intersection(params.policyType || [], template.policyType).length
      : true;

    return (
      isRequirementTypeMatched && isContextTypeMatched && isPolicyTypeMatched
    );
  });

  if (params.strict && !template) {
    throw new Error(
      `No template found for ${params.type} ${
        params.contextType || params.policyType
      }. Please update TEMPLATES constant to support this requirement.`
    );
  }

  if (!template) {
    if (params.type !== RequirementType.InsuranceCoverage) {
      // If the type is not insurance coverage, we can try to find a standard template
      template = TEMPLATES.find(template => {
        return template.requirementType === params.type &&
          !template.policyType &&
          Array.isArray(template.contextType)
          ? template.contextType.length === 0 ||
              template.contextType.includes(SharedFileRequestContextType.None)
          : [undefined, SharedFileRequestContextType.None].includes(
              template.contextType as SharedFileRequestContextType
            );
      });

      if (template) {
        return template;
      }
    }

    return {
      key: "generic",
      name: `${sentenceCase(params.type)} ${
        params.contextType || params.policyType
          ? params.contextType || params.policyType
          : ""
      }`.trim(),
      icon: "alert-circle",
      helperText: "Policy type not found",
      image: "",
      requirementType: RequirementType.InsuranceCoverage,
      policyType: params.policyType,
      tier: "SmartAdvanced",
      isBillable: true,
      modal: {
        description: "",
        exampleUseCases: "",
        cost: ""
      },
      form: null,
      costPerSubmission: 0,
      isRequirementWithErrorStates: false,
      isSmartAdvanced: true
    };
  }

  return template;
}
